import { api_GETExternal } from "api/axios.js";

const cep_api =
{
    getEnderecoByCep: function (cep) {
        const promise = new Promise((resolve, reject) => {
            api_GETExternal(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`).then(result => {
                resolve(result);
            });
        });

        return promise;
    },
}

export default cep_api
